






import {Component, Vue} from 'vue-property-decorator';
import {mapGetters} from "vuex";
import WorkerDashboard from "./WorkerDashboard.vue";
import CompanyDashboard from "./CompanyDashboard.vue";

@Component({
    components: { WorkerDashboard, CompanyDashboard},
    computed: {
        ...mapGetters({user: 'user', isWorker: 'isWorker', isCompany: 'isCompany'})
    },
    name: "Dashboard"
})
export default class Dashboard extends Vue {
    private user?: any;

}

